module.exports = __webpack_public_path__ + "static/media/profile_ico.4eb38ce1.svg";